





















































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import {
    deleteDenounce,
    getDenounces,
    patchDenounce,
    getPrograms,
    getNumberDenouncesPending,
} from '@/api/api';
import MetaDatatable from '../models/MetaDatatable';
import HeaderDatatable from '../models/HeaderDatatable';
import User from '../models/User';
import get from 'lodash/get';
import { roles, formatRoles } from '@/data/roles';
import PaginationDatatable from '../models/PaginationDatatable';
import SorterDatatable from '../models/SorterDatatable';
import Denounce from '../models/Denounce';
import Program from '../models/Program';
import {
    fetchPrescriberDenounce, fetchProgramDenounce,
    fetchProspectsAdminDenounce,
} from '@/utils/filters';
import FilterComponent from '@/components/FilterComponent.vue';
import Datatable from '@/components/Datatable.vue';
import { denouceStatus } from '@/data/denouceStatus';
import { formatDenounceProspectStatus } from '@/data/denounceProspectStatus';
import { projects } from '@/data/denounceProjects';
import SidebarModule from '../store/SidebarModule';
import formatCustomer from '@/utils/formatCustomer';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import Lot from "@/models/Lot";
import Boolean from "@/components/Boolean.vue";

@Component({
    components: {
        Datatable,
        FilterComponent,
        Boolean,
    },
    filters: {
        formatCustomer,
        formatDenounceProspectStatus,
        formatDate: (value: string) => {
            return value ? moment(value).format('L') : null;
        },
        formatDateHour: (value: string) => {
            return value ? moment(value).format('LT') : null;
        },
        fluxFormat: (value: boolean) => {
          if (value){
            return 'OUI';
          }else{
            return 'NON';
          }
        }
    },
})
export default class Denounces extends Vue {
    delete_comments: string = '';
    showDeleteCommentsPopUp: boolean = false;
    denounce: Denounce | null = null;
    denouncePop: Denounce | null = null;

    // NOUVELLES VARIABLES POUR LE RÉCAP DOCUMENTS
    showDocumentsRecapPopup: boolean = false;
    selectedDenounce: Denounce | null = null;

    yearModel: string = new Date().getFullYear().toString();

    projects = projects;

    // Types de documents attendus (basé sur ProgramDocument::TYPES)
    documentTypesList = [
        { key: 'images', label: 'Images du programme', essential: false },
        { key: 'documents_annual_charge', label: 'Décompte charge et 3 AG', essential: true },
        { key: 'documents_notice', label: 'Notice descriptive', essential: true },
        { key: 'documents_parking_plan', label: 'Plan des parkings', essential: false },
        { key: 'documents_floor_plan', label: 'Plan des étages', essential: true },
        { key: 'documents_global_plan', label: 'Plan de masse', essential: false },
        { key: 'documents_booking_contract', label: 'Doc Contrat Résa', essential: true },
        { key: 'documents_works_contract', label: 'Marché de travaux', essential: false },
        { key: 'documents_commercial_brochure', label: 'Plaquette commerciale', essential: true },
        { key: 'documents_management_brochure', label: 'Relevé de gérance', essential: false },
        { key: 'documents_rental_agreement', label: 'Bail/relève gérance', essential: false },
        { key: 'documents_general_assembly', label: 'Assemblée générale', essential: false },
        { key: 'documents_autres', label: 'Autres', essential: false },
    ];

    popupLots = false;
    lots: Lot | null = null;
    prescriber: string = '';
    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 20,
        search: null,
        orderBy: 'status',
        orderWay: 'ASC',
        filters: {
            prescriber: undefined,
            program: undefined,
            status: undefined,
            statusPrescriber: undefined,
            customer:undefined,
            year: new Date().getFullYear().toString()
        },
    };
    meta: MetaDatatable = cloneDeep(this.defaultMeta);
    columns: HeaderDatatable[] = [
        {
          title: 'Date Dénonce',
          dataIndex: 'created_at',
          scopedSlots: {
            customRender: 'date',
          },
          sorter: true,
        },
        {
          title: 'Statut',
          dataIndex: 'status',
          scopedSlots: {
            customRender: 'status',
          },
          sorter: true,
          defaultSortOrder: 'ascend',
        },
        {
          title: 'Opérateur',
          dataIndex: 'operator',
          scopedSlots: {
            customRender: 'operator',
          }
        },
        {
            title: 'Prescripteur',
            dataIndex: 'customer.prescriber',
            sorter: true,
            scopedSlots: {
                customRender: 'prescriber',
            },
        },
        {
            title: 'Statut prescripteur',
            dataIndex: 'customer.prescriber.family',
            sorter: true,
        },
        {
          title: 'Prospect acquéreur',
          dataIndex: 'customer',
          sorter: true,
          scopedSlots: {
            customRender: 'customer',
          },
        },
        {
            title: 'Projet',
            dataIndex: 'project',
            sorter: true,
            scopedSlots: {
                customRender: 'project',
            }
        },
        {
            title: 'Commentaire',
            dataIndex: 'message_text',
            sorter: true,
        },
        {
            title: 'Programme',
            dataIndex: 'program',
            sorter: true,
            scopedSlots: {
                customRender: 'program',
            },
        },
        {
            title: 'Promoteur',
            dataIndex: 'program.promoter',
            sorter: true,
            scopedSlots: {
                customRender: 'promoter',
            },
        },
        {
          title: 'Flux Connecté',
          dataIndex: 'program.promoter.api_connected',
          sorter: false,
          scopedSlots: {
            customRender: 'boolean',
          },
        },
        {
          title: 'Date Sauv MAJ',
          dataIndex: 'program.updated_at',
          sorter: false,
          scopedSlots: {
            customRender: 'date',
          },
        },
        {
          title: 'Lots sélectionnés',
          dataIndex: 'lots',
          sorter: true,
          scopedSlots: {
            customRender: 'lots',
          },
        },
        {
            title: 'Type',
            dataIndex: 'customer.status',
            scopedSlots: {
                customRender: 'status_prospect',
            },
            sorter: true,
        },
        {
            title: 'Ville du bien',
            dataIndex: 'program.address.city',
            sorter: true,
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            scopedSlots: {
                customRender: 'actions',
            },
            fixed: 'right',
        },
    ];

    async showPopup(denounce: Denounce,lots: Lot, prescriber: string) {
        this.lots = lots;
        this.denouncePop = denounce;
        this.prescriber = prescriber;
        this.popupLots = true;
    }

    async created() {
        const { data } = await getNumberDenouncesPending();
        console.log('denounce pending', data);

        this.prescriberModel = undefined;
        this.programModel = undefined;
        this.statusModel = undefined;
        this.statutPrescriberModel = undefined;
        this.customersModel = undefined;
        this.yearModel = new Date().getFullYear().toString();
    }

    async fetch(meta: MetaDatatable) {
        const { data } = await getDenounces({
            ...meta,
            page: meta.page - 1,
        });
        return data;
    }
    deleteText = {
        confirm: {
            title: `Suppression de la dénonce`,
            content: `Voulez-vous vraiment supprimer la dénonce ?`,
        },
        notify: {
            title: 'Dénonce supprimé',
            content: `La dénonce a bien été supprimé`,
        },
    };
    editText = {
        notify: {
            title: 'Dénonce modifié',
            content: `La dénonce a bien été modifiée`,
        },
    };

    // Prescibers
    get fetchPrescriber() {
        return fetchPrescriberDenounce;
    }

    //Customers
    get fetchCustomer(){
        return fetchProspectsAdminDenounce;
    }

    getProjectDenounce(project: any): any {
        return this.projects[project];
    }

    // Programs
    get fetchPrograms() {
        return fetchProgramDenounce;
    }

    get yearOptions() {
        const currentYear = new Date().getFullYear();
        const years = [];
        
        for (let year = currentYear; year >= 2021; year--) {
            years.push({
                text: year.toString(),
                value: year.toString()
            });
        }
        
        return years;
    }

    @Watch('yearModel', { immediate: true })
    onYearModel() {
        if (this.yearModel) {
            this.meta.filters = {
                ...this.meta.filters,
                year: this.yearModel
            };
        }
    }

    async actionDatatable(ev: {
        action: 'show' | 'edit' | 'delete' | 'add';
        item?: Denounce | null;
    }) {
        const action = ev.action;
        const denounce: Denounce | null = ev.item || null;
        switch (ev.action) {
            case 'edit':
                if (denounce && denounce.id) {
                    let editStatus: Denounce = {
                        status: denounce.status,
                    };

                    if(denounce && denounce.id && denounce.delete_comments) {
                        editStatus.delete_comments = denounce.delete_comments
                    }
                    await patchDenounce(denounce.id, editStatus);
                }
                break;
            case 'delete':
                if (denounce && denounce.id) {
                    this.meta = {
                        total: this.meta.total || 0,
                        pages: this.meta.pages || 0,
                        page: this.meta.page || 0,
                        perPage: this.meta.perPage || 10,
                        search: this.meta.search || null,
                        orderBy: this.meta.orderBy || null,
                        orderWay: this.meta.orderWay || null,
                        filters: this.meta.filters || null,
                    };

                    denounce.status = 'canceled';
                    
                    await deleteDenounce(denounce.id);
                }
                break;
        }
        await SidebarModule.fetchPendingDenounces();
    }

    deleteDialog(denounce: Denounce) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: this.deleteText.confirm.title,
            text: this.deleteText.confirm.content,
            accept: () => this.acceptDeleteAlert(denounce),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    // MÉTHODE MODIFIÉE: editStatus avec logique spéciale pour "accepted"
    async editStatus(denounce: Denounce) {
        const $vs = (this as any).$vs;

        if (this.messageError) {
            return;
        }

        // ✅ NOUVELLE LOGIQUE: Si le statut est "accepted", afficher le récap documents
        if (denounce.status === 'accepted' || denounce.status === 'waiting') {
            this.selectedDenounce = denounce;
            this.showDocumentsRecapPopup = true;
            
            // Générer un commentaire par défaut basé sur l'état des documents
            this.delete_comments = this.generateDefaultComment(denounce);
            return;
        }

        // Sinon, continuer avec le flux normal pour les autres statuts
        if (!this.delete_comments) {
            this.showDeleteCommentsPopUp = true;
            let lotsStr = ' ';
            if (denounce.lots) {
                //@ts-ignore
                denounce.lots.forEach(el => lotsStr = lotsStr + '- Lot ' + el.name + '\n')
            }
            this.delete_comments = lotsStr;
            this.denounce = denounce;
            return;
        } else {
            denounce.delete_comments = this.delete_comments;
            this.delete_comments = '';
        }

        try {
            await this.actionDatatable({ action: 'edit', item: denounce });

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: this.editText.notify.title,
                text: this.editText.notify.content,
            });
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la modification de la dénonce`
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }

    async acceptDeleteAlert(denounce: Denounce) {
        const $vs = (this as any).$vs;
        try {
            await this.actionDatatable({ action: 'delete', item: denounce });

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: this.deleteText.notify.title,
                text: this.deleteText.notify.content,
            });

            const $datatable = this.$refs.datatable as Datatable;
            $datatable.refresh();
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la suppression de la dénonce`
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }

    get denouceStatusArr() {
        return Object.keys(denouceStatus).map(key => ({
            text: (denouceStatus as any)[key],
            value: key,
        }));
    }

    // NOUVELLES MÉTHODES POUR LE RÉCAP DOCUMENTS
    getProgramDocuments(documentType: string) {
        if (!this.selectedDenounce || !this.selectedDenounce.program || !this.selectedDenounce.program.documents) {
            return [];
        }
        
        const filtered = this.selectedDenounce.program.documents.filter(
            (doc: any) => {
                return doc.type === documentType && (doc.deletedAt === null || doc.deletedAt === undefined);
            }
        );
        
        return filtered;
    }

    getDocumentCount(documentType: string): number {
        // Cas spécial pour les images
        if (documentType === 'images') {
            return this.getImageCount();
        }
        
        // Cas normal pour les documents
        return this.getProgramDocuments(documentType).length;
    }

    getImageCount(): number {
        if (!this.selectedDenounce || !this.selectedDenounce.program || !this.selectedDenounce.program.images) {
            return 0;
        }
        
        return Array.isArray(this.selectedDenounce.program.images) 
            ? this.selectedDenounce.program.images.length 
            : (this.selectedDenounce.program.images ? 1 : 0);
    }

    getDocumentStatusClass(documentType: string): string {
        const count = this.getDocumentCount(documentType);
        const docTypeInfo = this.documentTypesList.find(d => d.key === documentType);
        
        if (count === 0 && docTypeInfo && docTypeInfo.essential) {
            return 'border-red-200 bg-red-50';
        } else if (count === 0) {
            return 'border-yellow-200 bg-yellow-50';
        } else {
            return 'border-green-200 bg-green-50';
        }
    }

    getDocumentIndicatorClass(documentType: string): string {
        const count = this.getDocumentCount(documentType);
        const docTypeInfo = this.documentTypesList.find(d => d.key === documentType);
        
        if (count === 0 && docTypeInfo && docTypeInfo.essential) {
            return 'bg-red-500';
        } else if (count === 0) {
            return 'bg-yellow-500';
        } else {
            return 'bg-green-500';
        }
    }

    getDocumentCountClass(documentType: string): string {
        const count = this.getDocumentCount(documentType);
        const docTypeInfo = this.documentTypesList.find(d => d.key === documentType);
        
        if (count === 0 && docTypeInfo && docTypeInfo.essential) {
            return 'bg-red-100 text-red-800';
        } else if (count === 0) {
            return 'bg-yellow-100 text-yellow-800';
        } else {
            return 'bg-green-100 text-green-800';
        }
    }

    getTotalDocumentsPresent(): number {
        return this.documentTypesList.reduce((total, docType) => {
            return total + this.getDocumentCount(docType.key);
        }, 0);
    }

    getTotalDocumentsClass(): string {
        const essential = this.documentTypesList.filter(d => d.essential).length;
        const essentialPresent = this.documentTypesList
            .filter(d => d.essential)
            .reduce((count, docType) => {
                return count + (this.getDocumentCount(docType.key) > 0 ? 1 : 0);
            }, 0);

        if (essentialPresent === essential) {
            return 'bg-green-100 text-green-800';
        } else if (essentialPresent > essential / 2) {
            return 'bg-yellow-100 text-yellow-800';
        } else {
            return 'bg-red-100 text-red-800';
        }
    }

    getMissingDocuments(): string[] {
        return this.documentTypesList
            .filter(docType => {
                return this.getDocumentCount(docType.key) === 0;
            })
            .map(docType => docType.key);
    }

    getDocumentLabel(documentType: string): string {
        const docType = this.documentTypesList.find(d => d.key === documentType);
        return docType ? docType.label : documentType;
    }

    formatDate(dateString: string): string {
        return dateString ? moment(dateString).format('DD/MM/YYYY') : '';
    }

    getDocumentUrl(document: any): string {
        // Construire l'URL complète du document
        const baseUrl = window.location.origin;
        return `${baseUrl}${document.url}${document.name}.${document.extension}`;
    }

    // Méthode pour générer un commentaire par défaut
    generateDefaultComment(denounce: Denounce): string {
        const programName = (denounce.program && denounce.program.name) || 'le programme';
        const programCity = (denounce.program && denounce.program.address && denounce.program.address.city) || '';
        const promoterName = (denounce.program && denounce.program.promoter && denounce.program.promoter.name) || '';
        
        let comment = `Dénonce acceptée pour le programme "${programName}"`;
        
        if (programCity) {
            comment += ` à ${programCity}`;
        }
        
        if (promoterName) {
            comment += ` (Promoteur: ${promoterName})`;
        }
        
        comment += '.\n\n';
        
        // Ajouter les informations des lots
        if (denounce.lots && Array.isArray(denounce.lots) && denounce.lots.length > 0) {
            comment += `Lots concernés :\n`;
            denounce.lots.forEach((lot: any) => {
                comment += `- Lot ${lot.name}`;
                if (lot.type) {
                    comment += ` (${lot.type})`;
                }
                if (lot.type2) {
                    comment += ` - ${lot.type2}`;
                }
                comment += '\n';
            });
        }
        
        comment += `\nValidation effectuée le ${new Date().toLocaleDateString('fr-FR')}.`;
        
        return comment;
    }

    // Méthodes utilitaires pour le commentaire par défaut (simplifiées)
    getDocumentCountForDenounce(denounce: Denounce, documentType: string): number {
        if (!denounce.program) return 0;

        if (documentType === 'images') {
            if (!denounce.program.images) return 0;
            return Array.isArray(denounce.program.images) 
                ? denounce.program.images.length 
                : (denounce.program.images ? 1 : 0);
        }

        if (!denounce.program.documents) return 0;
        return denounce.program.documents.filter(
            (doc: any) => doc.type === documentType && (doc.deletedAt === null || doc.deletedAt === undefined)
        ).length;
    }

    getTotalDocumentsPresentForDenounce(denounce: Denounce): number {
        return this.documentTypesList.reduce((total, docType) => {
            return total + this.getDocumentCountForDenounce(denounce, docType.key);
        }, 0);
    }

    // Méthodes pour gérer la popup documents
    cancelDocumentsRecap(): void {
        this.showDocumentsRecapPopup = false;
        this.selectedDenounce = null;
        this.delete_comments = '';
    }

    async validateDenounceWithDocuments() {
        if (!this.selectedDenounce || !this.selectedDenounce.status || !this.delete_comments.trim()) {
            return;
        }

        this.showDocumentsRecapPopup = false;
        
        try {
            // Utiliser la logique normale d'édition
            this.selectedDenounce.delete_comments = this.delete_comments;
            await this.actionDatatable({ action: 'edit', item: this.selectedDenounce });

            const $vs = (this as any).$vs;
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: this.editText.notify.title,
                text: this.editText.notify.content,
            });
            
            // Rafraîchir le datatable
            const $datatable = this.$refs.datatable as any;
            if ($datatable && $datatable.refresh) {
                $datatable.refresh();
            }
            
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la modification de la dénonce`
            );

            const $vs = (this as any).$vs;
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }

        // Nettoyage
        this.selectedDenounce = null;
        this.delete_comments = '';
    }

    /**
     * Ant design considére null comme une string vide et donc masque le
     * placeholder, du coup il faut mettre à null, puis mettre à undefined
     */
    prescriberModel: string | undefined | null = null;
    programModel: string | undefined | null = null;
    statusModel: string | undefined | null = null;
    statutPrescriberModel: string | undefined | null = null;
    customersModel: string | undefined | null = null;

    get statusPrescripteurValues(){
        return [
            { text: 'CGPi', value: 'CGPi' },
            { text: 'CGP Mandataire', value: 'CGP Mandataire' },
            {
                text: 'Conseiller Immobilier Neuf carte T',
                value: 'Conseiller Immobilier Neuf carte T',
            },
            {
                text: 'Conseiller Immobilier Neuf Mandataire',
                value: 'Conseiller Immobilier Neuf Mandataire',
            },
            { text: 'CIF', value: 'CIF' },
            {
                text: 'Agent Immobilier Ancien Carte T',
                value: 'Agent Immobilier Ancien Carte T',
            },
            {
                text: 'Mandataire Immobilier Ancien',
                value: 'Mandataire Immobilier Ancien',
            },
        ]
    }

    @Watch('meta', { deep: true, immediate: true })
    onMeta() {
        if (this.meta.filters && this.meta.filters.prescriber) {
            this.prescriberModel = this.meta.filters.prescriber;
        } else {
            this.prescriberModel = undefined;
        }

        if (this.meta.filters && this.meta.filters.program) {
            this.programModel = this.meta.filters.program;
        } else {
            this.programModel = undefined;
        }

        if (this.meta.filters && this.meta.filters.status) {
            this.statusModel = this.meta.filters.status;
        } else {
            this.statusModel = undefined;
        }

        if (this.meta.filters && this.meta.filters.statusPrescriber) {
            this.statutPrescriberModel = this.meta.filters.statusPrescriber;
        } else {
            this.statutPrescriberModel = undefined;
        }

        if (this.meta.filters && this.meta.filters.customer) {
            this.customersModel = this.meta.filters.customer;
        } else {
            this.customersModel = undefined;
        }
        if (this.meta.filters && this.meta.filters.year) {
        this.yearModel = this.meta.filters.year;
        } else {
            this.yearModel = new Date().getFullYear().toString();
        }
    }

    @Watch('prescriberModel', { immediate: true })
    onPrescriberModel() {
        if (this.prescriberModel) {
            this.meta.filters ={
                prescriber: this.prescriberModel
            };
        } else if (this.meta.filters) {
            this.meta.filters = {
                prescriber: null
            };
        }
    }

    onStatutPrescriberModel(){

        if (this.statutPrescriberModel) {
            this.meta.filters = {
                statusPrescriber: this.statutPrescriberModel
            };
        } else if (this.meta.filters) {
            this.meta.filters ={
                statusPrescriber: null
            };
        }
    }
    @Watch('customersModel', { immediate: true })
    onCustomersModel(){
        if (this.customersModel) {
            this.meta.filters = {
                customer: this.customersModel
            };
        } else if (this.meta.filters) {
            this.meta.filters = {
                customer: null
            };
        }
    }

    @Watch('programModel', { immediate: true })
    onProgramModel() {
        if (this.programModel) {
            this.meta.filters = {
                program: this.programModel
            };
        } else if (this.meta.filters) {
            this.meta.filters = {
                program: null
            };
        }
    }

    @Watch('statusModel', { immediate: true })
    onStatusModel() {
        if (this.statusModel) {
            this.meta.filters = {
                status: this.statusModel
            };
        } else if (this.meta.filters) {
            this.meta.filters = {
                status: null
            };
        }
    }
    get messageError() {
        if (this.delete_comments.length > 400) {
            console.log(this.delete_comments.length)
            return '400 caractères maximum';
        }

        return null;
    }
}
